import { Checkbox, FormControlLabel } from "@mui/material";
import { ChangeEvent } from "react";

export interface ICheckboxInputProps {
    label: string;
    value: boolean;
    onChange: (value:boolean) => void;
}

export function CheckboxInput(props: ICheckboxInputProps) {

    const onChange = (event: ChangeEvent<HTMLInputElement>) => {
        props.onChange(event.target.checked)
    }

    return (
        <FormControlLabel
         label={props.label}
         control={
            <Checkbox
                checked={props.value}
                onChange={onChange}
                inputProps={{ 'aria-label': 'controlled' }}
            />}
        />
    )

}